/**
 * AH – Features Section  |  Nasalix Shopify Theme
 * File: assets/ah-features.js
 *
 * Static section — only hover transform is defined in CSS (transition: transform 0.3s).
 * No additional JS behaviour. Shopify Theme Editor events only.
 */

(function ($) {
  'use strict';

  document.addEventListener('shopify:section:select', function (e) {
    var el = document.getElementById('ah-features-' + e.detail.sectionId);
    if (!el) return;
    el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  });

  document.addEventListener('shopify:block:select', function (e) {
    var sectionEl = document.getElementById('ah-features-' + e.detail.sectionId);
    if (!sectionEl) return;
    var blockEl = sectionEl.querySelector('[data-block-id="' + e.detail.blockId + '"]');
    if (blockEl) blockEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  });

})(jQuery);